import { DetailsHTMLAttributes } from 'react';

import './styles/button-close.scss';

type Props = Omit<DetailsHTMLAttributes<HTMLButtonElement>, 'title'| 'aria-label'>

const ButtonClose = (props:Props) => (
  <button { ...props } title="Close Modal" type="button" aria-label="Close Modal Button" className="button-close">
    <span className="is-sr-only">Close Modal</span>
  </button>
);

export default ButtonClose;